/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import { connect } from 'react-redux';
import {
  selectStructuralResponseReturnPeriodsByKey,
  selectStructuralResponseDataForDirectionWithLocationLabelsByLocation,
} from '#selectors/entities/models.js';
import StructuralResponseTable from './StructuralResponseTable.jsx';

const mapStateToProps = (state, ownProps) => {
  const { modelId, direction, edpKey, responseItemKey } = ownProps;

  const responseDataByLocation =
    selectStructuralResponseDataForDirectionWithLocationLabelsByLocation(state, {
      modelId,
      edpKey,
      responseItemKey,
      direction,
    });

  const returnPeriods = selectStructuralResponseReturnPeriodsByKey(state, {
    modelId,
    responseItemKey,
    direction,
  });

  return {
    returnPeriods,
    responseDataByLocation,
  };
};

export default connect(mapStateToProps)(StructuralResponseTable);
